module.exports = __webpack_public_path__ + "static/img/thumb_2.a1d57d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/thumb_2.png
// module id = yAZF
// module chunks = 1